import ApiCore from './api-core'
import { PUBLIC } from '@/constants/api-types'

export default class FinancialBank extends ApiCore {
  constructor(store) {
    const path = `${PUBLIC}/financial/bank`
    super(store, path)
  }

  list(showProgress) {
    return this.request({
      action: 'list',
      method: 'GET',
      showProgress
    })
  }
}
